import * as React from "react";
import { Block } from "../Block";
import { paddedArray } from "../utils/arrays";

type TBlockProps = React.ComponentProps<typeof Block>;

type TBlockGrid = {
  columns: (string | number)[];
  gridColumnGap?: [string | null, string | null, string, string];
  gridRowGap?: [string, string, string, string];
  justifyContent?: string;
  justifyItems?: string;
} & TBlockProps;

interface Props {
  columns: (string | number)[];
  gridColumnGap?: [string | null, string | null, string, string];
  gridRowGap?: [string, string, string, string];
  justifyContent?: string;
  justifyItems?: string;
}

export const BlockGrid: React.FC<TBlockGrid> = ({
  columns,
  gridColumnGap = [null, null, "scale800", "scale800"],
  gridRowGap = ["scale600", "scale600", "scale800", "scale800"],
  justifyContent = "center",
  justifyItems = "center",
  ...props
}: Props) => {
  columns = columns || [1, 1, 2, 2];

  columns = paddedArray(columns, 4);
  columns = [...columns].map((value, _) =>
    value === 1 ? "1fr" : Number.isInteger(value) ? `repeat(${value}, 1fr)` : value
  );

  return (
    <Block
      display="grid"
      gridTemplateColumns={columns}
      gridColumnGap={gridColumnGap}
      gridRowGap={gridRowGap}
      justifyContent={justifyContent}
      justifyItems={justifyItems}
      {...props}
    />
  );
};
